import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal} from 'react-bootstrap';
import styles from './styles.module.scss';

const PopupWarning = ({generalNotes, transferNotes, disabled, handleAction}) => {
  const [show, setShow] = useState(false);
  const handleShowModal = () => setShow(true);
  const handleCloseModal = () => setShow(false);

  return (
    <>
      <button
        className={styles.btnSave}
        onClick={() => handleShowModal()}
        disabled={disabled}
      >
        <FormattedMessage id={'transfersByAgent-popup-warning-save'} defaultMessage={'Save transfer'}/>
      </button>
      <Modal show={show} onHide={handleCloseModal}>
        <Modal.Body>
          <h5 className={styles.headerText}>{generalNotes}</h5>
          <h5 className={styles.headerText}>{transferNotes}</h5>
          <div className={styles.actions}>
            <button
              className={styles.btnCancel}
              onClick={() => handleCloseModal()}
            >
              <FormattedMessage id={'label-button-cancel'} defaultMessage={'Cancel'}/>
            </button>
            <button
              className={styles.btnSave}
              onClick={() => {
                handleAction();
                handleCloseModal();
              }}
            >
              <FormattedMessage id={'label-button-confirm'} defaultMessage={'Save'}/>
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupWarning;